const OPS_HOSTS = new Set([
  "ops.recipesenplace.com",
  "ops.getenplace.com",
]);

/**
 * The Replit application router is path-based, so a custom hostname still
 * reaches the root recipe-library artifact at `/`. Send Ops host roots to the
 * separately registered Ops Console path before the customer app boots.
 */
export function opsConsoleRedirectUrl(location: {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}): string | null {
  const hostname = location.hostname.toLowerCase().replace(/\.$/, "");
  const pathname = location.pathname.replace(/\/+$/, "") || "/";

  if (!OPS_HOSTS.has(hostname) || pathname !== "/") return null;
  return `/ops-console/${location.search}${location.hash}`;
}